import { CreditCard, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CardButtons({
  isPaxEnabled, paxSettings, remainingBalance, belowMin, surchargeAmount,
  fsEligibleTotal, ebtFoodCap, processCardPayment, onAddSurcharge, styles
}) {
  if (!isPaxEnabled) return null;
  const { buttonFont, buttonSize, buttonWeight } = styles;

  return (
    <>
      <div className="flex gap-1.5 mt-2 pt-2 border-t border-zinc-200">
        <Button
          data-testid="pay-credit-btn"
          onClick={() => {
            if (belowMin && surchargeAmount > 0 && onAddSurcharge) {
              onAddSurcharge(surchargeAmount);
              processCardPayment("CREDIT", null, surchargeAmount);
            } else {
              processCardPayment("CREDIT");
            }
          }}
          className="flex-1 h-[60px] bg-blue-600 hover:bg-blue-700 text-white rounded-xl"
          style={{ fontFamily: `${buttonFont}, sans-serif`, fontSize: `${buttonSize}px`, fontWeight: buttonWeight }}
        >
          <div className="flex flex-col items-center leading-tight">
            <span className="flex items-center gap-1"><CreditCard className="w-4 h-4" /> CREDIT</span>
            {belowMin && surchargeAmount > 0 && (
              <span className="text-[10px] font-normal opacity-90">+${surchargeAmount.toFixed(2)} FEE</span>
            )}
          </div>
        </Button>
        <Button
          data-testid="pay-debit-btn"
          onClick={() => {
            if (belowMin && surchargeAmount > 0 && onAddSurcharge) {
              onAddSurcharge(surchargeAmount);
              processCardPayment("DEBIT", null, surchargeAmount);
            } else {
              processCardPayment("DEBIT");
            }
          }}
          className="flex-1 h-[60px] bg-purple-600 hover:bg-purple-700 text-white rounded-xl"
          style={{ fontFamily: `${buttonFont}, sans-serif`, fontSize: `${buttonSize}px`, fontWeight: buttonWeight }}
        >
          <div className="flex flex-col items-center leading-tight">
            <span className="flex items-center gap-1"><Smartphone className="w-4 h-4" /> DEBIT</span>
            {belowMin && surchargeAmount > 0 && (
              <span className="text-[10px] font-normal opacity-90">+${surchargeAmount.toFixed(2)} FEE</span>
            )}
          </div>
        </Button>
        {paxSettings?.ebt_foodstamp_enabled && (
          <Button
            data-testid="pay-ebt-food-btn"
            onClick={() => processCardPayment("EBT_FOOD", ebtFoodCap)}
            className="flex-1 h-[60px] bg-green-600 hover:bg-green-700 text-white rounded-xl"
            style={{ fontFamily: `${buttonFont}, sans-serif`, fontSize: `${buttonSize}px`, fontWeight: buttonWeight }}
            disabled={ebtFoodCap <= 0}
          >
            <div className="flex flex-col items-center leading-tight">
              <span>EBT FOOD</span>
              {ebtFoodCap > 0 && (
                <span className="text-[10px] font-normal opacity-90">${Math.min(ebtFoodCap, remainingBalance).toFixed(2)}</span>
              )}
            </div>
          </Button>
        )}
        {paxSettings?.ebt_cash_enabled && (
          <Button
            data-testid="pay-ebt-cash-btn"
            onClick={() => processCardPayment("EBT_CASH")}
            className="flex-1 h-[60px] bg-teal-600 hover:bg-teal-700 text-white rounded-xl"
            style={{ fontFamily: `${buttonFont}, sans-serif`, fontSize: `${buttonSize}px`, fontWeight: buttonWeight }}
          >
            EBT CASH
          </Button>
        )}
      </div>

      {belowMin && surchargeAmount > 0 && (
        <div className="text-center text-xs text-amber-600 bg-amber-50 rounded-lg py-1.5">
          Below ${paxSettings?.min_credit_debit_amount?.toFixed(2) || '0.00'} minimum — ${surchargeAmount.toFixed(2)} FEE applies for Credit/Debit
        </div>
      )}
    </>
  );
}
